import { useEffect } from "react";
import { X, Camera, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ items, index, onClose, onPrev, onNext }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onPrev, onNext]);

  if (index === null || index === undefined) return null;
  const item = items[index];

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-6"
      style={{ background: "rgba(10,10,12,0.92)" }}
      onClick={onClose}
      data-testid="lightbox-overlay"
    >
      <button
        onClick={onClose}
        data-testid="lightbox-close"
        className="absolute top-6 right-6"
        style={{ color: "var(--gold)" }}
        aria-label="Close"
      >
        <X size={30} strokeWidth={1.5} />
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        className="absolute left-6"
        style={{ color: "var(--text-light)" }}
        aria-label="Previous"
        data-testid="lightbox-prev"
      >
        <ChevronLeft size={40} strokeWidth={1.5} />
      </button>
      <div
        className="w-full max-w-4xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="lightbox-content"
      >
        {item.src ? (
          <img
            src={item.src}
            alt={item.alt}
            style={{ width: "100%", maxHeight: "82vh", objectFit: "contain", borderRadius: 8, display: "block", margin: "0 auto" }}
          />
        ) : (
          <div className="photo-ph ratio-16-10">
            <div className="flex flex-col items-center gap-3 relative z-10">
              <Camera size={44} strokeWidth={1.5} style={{ color: "var(--gold)" }} />
              <span className="uppercase" style={{ color: "rgba(245,242,236,0.7)", fontSize: "13px", letterSpacing: "0.1em" }}>
                {item.alt}
              </span>
            </div>
          </div>
        )}
        {item.alt ? (
          <p className="text-center mt-4" style={{ color: "rgba(245,242,236,0.72)", fontSize: 14 }}>{item.alt}</p>
        ) : null}
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        className="absolute right-6"
        style={{ color: "var(--text-light)" }}
        aria-label="Next"
        data-testid="lightbox-next"
      >
        <ChevronRight size={40} strokeWidth={1.5} />
      </button>
    </div>
  );
};
